import { render, staticRenderFns } from "./GrupaStatusaForma.vue?vue&type=template&id=7e62c031&scoped=true&"
import script from "./GrupaStatusaForma.vue?vue&type=script&lang=js&"
export * from "./GrupaStatusaForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e62c031",
  null
  
)

export default component.exports